import { BaseEntity } from '../base-entity';


export class HtmlTemplate extends BaseEntity {
  public name: string;
  public documentName: string;

  public html: string;
  public previewHtml: string;
  public mjml: string;

  public htmlEn: string;
  public previewHtmlEn: string;
  public mjmlEn: string;
}

export class PushNotificationTemplate extends BaseEntity {
  createDate: Date;
  name: string;
  bodyTitleDe: string;
  bodyTextDe: string;
  notificationTitleDe: string;
  notificationTextDe: string;
  actionLabelDe: string;
  bodyTitleEn: string;
  bodyTextEn: string;
  notificationTitleEn: string;
  notificationTextEn: string;
  actionLabelEn: string;
  data: { [key: string]: string };

  action: string;
  actionParameter: string|null;

  constructor() {
    super();
    this.createDate = new Date();
    this.name = "";
    this.bodyTitleDe = "";
    this.bodyTextDe = "";
    this.notificationTitleDe = "";
    this.notificationTextDe = "";
    this.bodyTitleEn = "";
    this.bodyTextEn = "";
    this.notificationTitleEn = "";
    this.notificationTextEn = "";
    this.action = "";
    this.actionLabelEn = "";
    this.actionLabelDe = "";
    this.data = {};
    this.actionParameter = null;
  }
}
